import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { AnalyticsService } from '../../services/analytics.service';
import * as $ from "jquery";
import "bootstrap-datepicker";
import './form-item-shariah-overdraft.component.scss';
var regYearValid = true;
var regTypeValid = true;
var FormItemShariahOverdraft = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemShariahOverdraft, _super);
    function FormItemShariahOverdraft(element) {
        var _this = _super.call(this, element) || this;
        _this.isRegMatchingEntity = true;
        _this.isRegYearValid = true;
        return _this;
    }
    FormItemShariahOverdraft.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        // buttons
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js-shariah-overdraft__button"));
        // display views
        if (this.applyForm) {
            this.displayLoader = this.applyForm.querySelector(".form__loader--container");
            this.displayFields = this.applyForm.querySelector(".form__fields--container");
            this.displaySuccess = this.applyForm.querySelector(".form__success--container");
            this.displayFail = this.applyForm.querySelector(".form__error--container");
        }
        this.formDatePicker = this.element.querySelector('.js-date-picker');
        this.formTimePicker = this.element.querySelector('.js-time-picker');
        this.businessType = this.element.querySelector(".js-business-type");
        this.helpDropDown = this.element.querySelector(".js-enquiry-type");
        this.containerModal = this.element.closest('.form-item-shariah-overdraft');
        this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');
        this.initFieldLengths();
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-email");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingEmailTextArea = this.element.querySelector(".data-sharing-sms");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.publicHolidays = ['2018/01/01', '2018/03/21', '2018/03/30', '2018/04/02', '2018/04/27', '2018/05/01', '2018/06/16', '2018/08/09', '2018/09/24', '2018/12/16', '2018/12/17', '2018/12/25', '2018/12/26'];
        this.populateDatePicker();
        if (this.helpDropDown) {
            this.displayEnquiryForm(this.helpDropDown.value);
        }
    };
    FormItemShariahOverdraft.prototype.bindEvents = function () {
        var _this = this;
        if (this.formDatePicker) {
            this.formDatePicker.addEventListener("change", function (event) {
                _this.validateDate(event.target);
            });
        }
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
        this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
            _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute("hidden");
            _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsShowBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute("hidden");
            _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailShowBtn.removeAttribute("hidden");
        });
        this.applyFormSubmit.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        // Reset the form
        this.applyForm.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
        if (this.applyForm) {
            var _formFields = Array.from(this.applyForm.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.businessType) {
            this.businessType.addEventListener("change", function () { return _this.validateBusinessType("validate"); });
        }
        if (this.helpDropDown) {
            this.helpDropDown.addEventListener("change", function () {
                _this.displayEnquiryForm(_this.helpDropDown.value);
            });
        }
        var businessRegNumberElem = this.applyForm.querySelector("input[name=business-reg-number]");
        var entityTypeElem = this.applyForm.querySelector("select[name=business-type]");
        var businessRegNumber = businessRegNumberElem.value;
        var entityType = entityTypeElem.value;
        var regNumYear = businessRegNumber.split('/')[0];
        var currentYear = new Date().getFullYear();
        if (Number(regNumYear) > currentYear) {
            this.isRegYearValid = false;
            $('.business-reg-number-group').append("<div class=\"regYear_error form__group--error_message\"><ul><li>Registration number cannot be in the future</li></ul></div>");
            window.scrollTo(0, 0);
        }
        else {
            this.isRegYearValid = true;
            $('.regYear_error').remove();
        }
        if (businessRegNumber !== "") {
            switch (entityType) {
                case 'CLOSE':
                    // Close Corporation - CLOSE - 23
                    if (businessRegNumber.split('/')[2] !== '23') {
                        this.isRegMatchingEntity = false;
                        $('.business-reg-number-group').append("<div class=\"mismatch_error form__group--error_message\"><ul><li>Registration number does not match with the entity type</li></ul></div>");
                        window.scrollTo(0, 0);
                    }
                    else {
                        this.isRegMatchingEntity = true;
                        $('.mismatch_error').remove();
                    }
                    break;
                case 'PRIVATE':
                case 'SMALLBUSINESSCORP':
                case 'LLC':
                    // Private Company - PRIVATE - 07
                    // Small Business Corporation - SMALLBUSINESSCORP - 07
                    // Limited Liability - LLC - 07
                    if (businessRegNumber.split('/')[2] !== '07') {
                        this.isRegMatchingEntity = false;
                        $('.business-reg-number-group').append("<div class=\"mismatch_error form__group--error_message\"><ul><li>Registration number does not match with the entity type</li></ul></div>");
                        window.scrollTo(0, 0);
                    }
                    else {
                        this.isRegMatchingEntity = true;
                        $('.mismatch_error').remove();
                    }
                    break;
                case 'SOLE':
                    // Sole proprietor - SOLE - Must be SA id number, coverd by validation
                    this.isRegMatchingEntity = true;
                    $('.mismatch_error').remove();
                    break;
                default:
                    break;
            }
        }
        else {
            this.isRegMatchingEntity = true;
            $('.mismatch_error').remove();
        }
        if (this.businessType) {
            this.businessType.addEventListener("change", function (e) {
                if (e.target.value.toUpperCase() === 'SOLE') {
                    _this.element.querySelector('input[name=entity-identity-number]').parentElement.parentElement.classList.remove('hidden');
                    _this.element.querySelector('input[name=entity-identity-number]').classList.add('form__input--required');
                    _this.element.querySelector('input[name=business-reg-number]').parentElement.parentElement.classList.add('hidden');
                    _this.element.querySelector('input[name=business-reg-number]').classList.remove('form__input--required');
                }
                else {
                    _this.element.querySelector('input[name=entity-identity-number]').parentElement.parentElement.classList.add('hidden');
                    _this.element.querySelector('input[name=entity-identity-number]').classList.remove('form__input--required');
                    _this.element.querySelector('input[name=business-reg-number]').parentElement.parentElement.classList.remove('hidden');
                    _this.element.querySelector('input[name=business-reg-number]').classList.add('form__input--required');
                }
            });
        }
        this.element.querySelector('input[name=date]').addEventListener('input', function (e) {
            var value = e.target.value;
            var currentYear = new Date().getFullYear();
            var nextYear = currentYear + 1;
            // Remove all non-numeric characters
            value = value.replace(/[^0-9]/g, '');
            // Add formatting for MM/DD/YYYY
            if (value.length >= 2) {
                var month = value.slice(0, 2);
                month = Math.min(Math.max(parseInt(month), 1), 12).toString().padStart(2, '0'); // Ensure MM is between 01 and 12
                value = month + '/' + value.slice(2);
            }
            if (value.length >= 5) {
                var day = value.slice(3, 5);
                var month = parseInt(value.slice(0, 2));
                var year = parseInt(value.slice(6, 10)) || currentYear; // Default year if not fully entered
                // Dynamically adjust day limits based on month and year (consider leap year)
                var daysInMonth = new Date(year, month, 0).getDate();
                day = Math.min(Math.max(parseInt(day), 1), daysInMonth).toString().padStart(2, '0'); // Ensure DD is valid for the given month
                value = value.slice(0, 3) + day + '/' + value.slice(5);
            }
            if (value.length >= 10) {
                var year = value.slice(6, 10);
                year = Math.min(Math.max(parseInt(year), currentYear), nextYear).toString(); // Restrict year to current year or next year
                value = value.slice(0, 6) + year;
            }
            // Limit to 10 characters (MM/DD/YYYY)
            value = value.slice(0, 10);
            e.target.value = value;
        });
        this.element.querySelector('input[name=business-reg-number]').addEventListener('input', function (e) {
            var value = e.target.value;
            // Remove all non-numeric characters
            value = value.replace(/[^0-9]/g, '');
            // Apply the formatting
            if (value.length > 10) {
                value = value.slice(0, 4) + '/' + value.slice(4, 10) + '/' + value.slice(10, 12);
            }
            else if (value.length > 4) {
                value = value.slice(0, 4) + '/' + value.slice(4);
            }
            e.target.value = value;
        });
        this.element.querySelector('input[name=business-reg-number]').addEventListener('focusout', function (e) {
            var _form = document.querySelector(".form");
            var businessRegNumberElem = _form.querySelector("input[name=business-reg-number]");
            var entityTypeElem = _form.querySelector("select[name=business-type]");
            var businessRegNumber = businessRegNumberElem.value;
            var entityType = entityTypeElem.value;
            var regNumYear = businessRegNumber.split('/')[0];
            var currentYear = new Date().getFullYear();
            var businessRegNumberGroup = document.querySelector('.business-reg-number-group');
            var regYearErrorElem = document.querySelector('.regYear_error');
            var mismatchErrorElem = document.querySelector('.mismatch_error');
            if (Number(regNumYear) > currentYear) {
                regYearValid = false;
                if (!regYearErrorElem) {
                    var errorDiv = document.createElement('div');
                    errorDiv.classList.add('regYear_error');
                    errorDiv.innerHTML = '<ul><li>Registration number cannot be in the future</li></ul>';
                    businessRegNumberGroup.appendChild(errorDiv);
                    window.scrollTo(0, 0);
                }
            }
            else {
                regYearValid = true;
                $('.regYear_error').remove();
            }
            if (businessRegNumber !== "") {
                switch (entityType) {
                    case 'CLOSE':
                        // Close Corporation - CLOSE - 23
                        if (businessRegNumber.split('/')[2] !== '23') {
                            regTypeValid = false;
                            if (!mismatchErrorElem) {
                                var errorDiv = document.createElement('div');
                                errorDiv.classList.add('mismatch_error');
                                errorDiv.innerHTML = '<ul><li>Registration number does not match with the entity type</li></ul>';
                                businessRegNumberGroup.appendChild(errorDiv);
                                window.scrollTo(0, 0);
                            }
                        }
                        else {
                            regTypeValid = true;
                            $('.mismatch_error').remove();
                        }
                        break;
                    case 'PRIVATE':
                    case 'SMALLBUSINESSCORP':
                    case 'LLC':
                        // Private Company - PRIVATE - 07
                        // Small Business Corporation - SMALLBUSINESSCORP - 07
                        // Limited Liability - LLC - 07
                        if (businessRegNumber.split('/')[2] !== '07') {
                            regTypeValid = false;
                            if (!mismatchErrorElem) {
                                var errorDiv = document.createElement('div');
                                errorDiv.classList.add('mismatch_error');
                                errorDiv.innerHTML = '<ul><li>Registration number does not match with the entity type</li></ul>';
                                businessRegNumberGroup.appendChild(errorDiv);
                                window.scrollTo(0, 0);
                            }
                        }
                        else {
                            regTypeValid = true;
                            $('.mismatch_error').remove();
                        }
                        break;
                    case 'SOLE':
                        // Sole proprietor - SOLE - Must be SA id number, covered by validation
                        regTypeValid = true;
                        $('.mismatch_error').remove();
                        break;
                    default:
                        break;
                }
            }
            else {
                regTypeValid = true;
                $('.mismatch_error').remove();
            }
        });
    };
    FormItemShariahOverdraft.prototype.displayEnquiryForm = function (select) {
        var __tmpId = this.element.querySelector("input[name=entity-identity-number]");
        var __tmpReg = this.element.querySelector("input[name=business-reg-number]");
        var _tmpId = "";
        var _tmpReg = "";
        if (__tmpId) {
            _tmpId = __tmpId.closest(".form__group");
        }
        if (__tmpReg) {
            _tmpReg = __tmpReg.closest(".form__group");
        }
        switch (select) {
            case "Enquiry":
                this.businessType.classList.remove("form__input--required");
                if (_tmpId !== "") {
                    _tmpId.classList.add("form__group--hidden");
                    _tmpId.parentElement.classList.add("hidden");
                    _tmpId.querySelector("input").classList.remove("form__input--required");
                    _tmpId.querySelector("input").value = "";
                }
                if (_tmpReg !== "") {
                    _tmpReg.classList.add("form__group--hidden");
                    _tmpReg.parentElement.classList.add("hidden");
                    _tmpReg.querySelector("input").classList.remove("form__input--required");
                    _tmpReg.querySelector("input").value = "";
                }
                this.element.querySelector('select[name=business-type]').parentElement.parentElement.parentElement.classList.add('hidden');
                this.element.querySelector('select[name=business-type]').value = "";
                break;
            case "Application":
                this.businessType.classList.add("form__input--required");
                if (_tmpId !== "") {
                    _tmpId.classList.remove("form__group--hidden");
                    _tmpId.querySelector("input").classList.add("form__input--required");
                }
                if (_tmpReg !== "") {
                    _tmpReg.classList.remove("form__group--hidden");
                    _tmpReg.querySelector("input").classList.add("form__input--required");
                }
                this.element.querySelector('select[name=business-type]').parentElement.parentElement.parentElement.classList.remove('hidden');
                break;
        }
    };
    FormItemShariahOverdraft.prototype.validateBusinessType = function (type) {
        // Business Reg Validations
        function dfcBusinessFormatBusinessReg(event) {
            var _stringLength = parseFloat(event.length);
            var _newLength = (_stringLength - 1);
            var _check = event.substring(_newLength);
            var reg = new RegExp('^[0-9]+$');
            if (reg.test(_check)) {
                if (event.length === 4) {
                    event = event += '/';
                }
                else if (event.length === 11) {
                    event = event += '/';
                }
                else if (event.length > 14) {
                    event = event.substring(0, 14);
                }
            }
            else {
                return event.substring(0, _newLength);
            }
            return event;
        }
        function dfcBusinessFormatExpression(inputText) {
            var _check = inputText.split('/');
            if (_check.length > 1) {
                var _valid1 = true;
                var _valid2 = true;
                var _valid3 = true;
                if (_check.length === 3) {
                    var _seg1 = new RegExp('^/d{4}$');
                    var _seg2 = new RegExp('^/d{6}$');
                    var _seg3 = new RegExp('^/d{2}$');
                    if (_seg1.test(_check[0])) {
                        _valid1 = false;
                    }
                    if (_seg2.test(_check[1])) {
                        _valid2 = false;
                    }
                    if (_seg3.test(_check[2])) {
                        _valid3 = false;
                    }
                    if (_valid1 && _valid2 && _valid3) {
                        return inputText;
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return '';
                }
            }
            else if (inputText.length >= 12) {
                var _firstcharacters = inputText.substring(0, 4);
                var _secondCharacters = inputText.substring(5, 10);
                var _thirdCharacters = inputText.substring(11, 13);
                return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
            }
            return '';
        }
        function deleteContent(event) {
            if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                var reg = event.target.value;
                event.target.value = dfcBusinessFormatBusinessReg(reg);
            }
        }
        function addBlur(event) {
            var reg = event.target.value;
            event.target.value = dfcBusinessFormatExpression(reg);
        }
    };
    FormItemShariahOverdraft.prototype.initFieldLengths = function () {
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        _firstName.setAttribute("maxlength", "80");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        _surname.setAttribute("maxlength", "80");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNumber]");
        _contactNumber.setAttribute("maxlength", "10");
    };
    FormItemShariahOverdraft.prototype.populateDatePicker = function () {
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            var nextYear = new Date().getFullYear() + 1;
            $(this.formDatePicker).datepicker({
                startDate: this._startDate,
                format: 'mm/dd/yyyy',
                endDate: new Date(nextYear, 11, 31),
            });
        }
    };
    FormItemShariahOverdraft.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if ((_currentMin >= 30) && (_currentHour <= 15)) {
            _currentHour++;
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if ((_currentMin >= 30) && (_currentHour >= 15)) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        var _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
        for (var i = item.options.length - 1; i >= 0; i--) {
            if (item.options[i].value !== 'Anytime') {
                if ((item.options[i].value < _tmpTime) && (_enabledOptions === false)) {
                    // item.options[i].disabled = true;
                }
                else if (_enabledOptions === true) {
                    item.options[i].disabled = false;
                }
            }
        }
        return _currentDateTime;
    };
    FormItemShariahOverdraft.prototype.validSAContact = function (field) {
        var is_zero_number_correct = true;
        var num;
        num = /^0[0-9]\d{8}$/g;
        if (num.test(field.value) === false) {
            is_zero_number_correct = false;
        }
        else {
            is_zero_number_correct = true;
        }
        return is_zero_number_correct;
    };
    FormItemShariahOverdraft.prototype.validSAIDNo = function (field) {
        var idNumber = field.value;
        var year = Number(idNumber.substring(0, 2));
        var month = Number(idNumber.substring(2, 4));
        var day = Number(idNumber.substring(4, 6));
        // Determine the full year based on the first two digits of the ID number
        var currentYear = new Date().getFullYear() % 100;
        var fullYear;
        if (year <= currentYear) {
            fullYear = 2000 + year;
        }
        else {
            fullYear = 1900 + year;
        }
        // Check if the birthdate is valid
        if (fullYear < 1900 || fullYear > currentYear + 2000 || month < 1 || month > 12 || day < 1 || day > 31) {
            return false;
        }
        var idArray = idNumber.split('').map(Number);
        var checksum = idArray[12];
        var weightedSum = idArray
            .slice(0, 12)
            .map(function (digit, index) { return (index % 2 === 0 ? digit : digit * 2); })
            .map(function (digit) { return (digit > 9 ? digit - 9 : digit); })
            .reduce(function (acc, curr) { return acc + curr; }, 0);
        var calculatedChecksum = (10 - (weightedSum % 10)) % 10;
        return calculatedChecksum === checksum;
    };
    FormItemShariahOverdraft.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.remove("active");
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.remove("active");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.remove("active");
        this.displaySuccess.classList.add("hidden");
        this.displayFail.classList.remove("active");
        this.displayFail.classList.add("hidden");
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.add("active");
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.add("active");
                this.displaySuccess.classList.remove("hidden");
                break;
            case "fail":
                this.displayFail.classList.add("active");
                this.displayFail.classList.remove("hidden");
                break;
            default:
                this.displayLoader.classList.add("active");
                this.displayLoader.classList.remove("hidden");
                break;
        }
    };
    FormItemShariahOverdraft.prototype.closeForm = function () {
        var baseUrl = '/southafrica/business/products-and-services/borrow-for-your-needs/business-loans/shariah-overdraft';
        window.location.href = baseUrl;
    };
    FormItemShariahOverdraft.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            this.showDisplayView("fields");
        }
    };
    FormItemShariahOverdraft.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var _displayName = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var analyticsService = new AnalyticsService();
        // fields
        var _enquiry = this.applyForm.querySelector("select[name=enquiryType]");
        var _bank = this.applyForm.querySelector("select[name=bank]");
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        var _businessName = this.applyForm.querySelector("input[name=businessName]");
        var _province = this.applyForm.querySelector("select[name=province]");
        var _location = this.applyForm.querySelector("input[name=location]");
        var _registration = this.applyForm.querySelector("input[name=business-reg-number]");
        var _businessId = form.querySelector("input[name=entity-identity-number]");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNumber]");
        var _date = this.applyForm.querySelector("input[name=date]");
        var _time = this.applyForm.querySelector("select[name=time]");
        var _popiConsent = this.applyForm.querySelector("input[name=popia-consent]");
        var businessType = form.querySelector("select[name=business-type]");
        var _form = document.querySelector(".form");
        var yearValid = Array.from(_form.querySelectorAll(".regYear_error"));
        var regValid = Array.from(_form.querySelectorAll(".mismatch_error"));
        var errors = [];
        if (_contactNumber.value.length != 10) {
            errors.push('South African contact numbers are 10 digits');
        }
        if (!this.validSAContact(_contactNumber)) {
            errors.push('This contact number is invalid');
        }
        if (errors.length !== 0) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            this.validationService.addErrorMessage(_contactNumber, errors);
            return;
        }
        this.companyRegistrationOrId = this.businessType.value === 'SOLE' ? _businessId.value : _registration.value.replaceAll('/', '');
        var _postData = {
            email: "shariah@standardbank.co.za",
            recipient: "shariah@standardbank.co.za",
            subject: "Shariah Overdraft",
            enquiry: (_enquiry ? _enquiry.value : ""),
            entityType: (businessType ? businessType.value.replace(/_/g, " ") : ""),
            bank: (_bank ? _bank.value : ""),
            firstname: (_firstName ? _firstName.value : ""),
            surname: (_surname ? _surname.value : ""),
            businessName: (_businessName ? _businessName.value : ""),
            province: (_province ? _province.value : ""),
            location: (_location ? _location.value : ""),
            registration: this.companyRegistrationOrId,
            contact: (_contactNumber ? _contactNumber.value : ""),
            date: (_date ? _date.value : ""),
            time: (_time ? _time.value : ""),
            popiConsent: ((_popiConsent && _popiConsent.checked) ? "YES" : "NO"),
            formLocation: "/southafrica/personal/products-and-services/borrow-for-your-needs/vehicle-financing/application",
            dataSharingWithinOurGrpMarketingConsent: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-group'),
            dataSharingWithThirdPartiesMarketingConsent: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-3rd-party'),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-boarders'),
            dataSharingTelesale: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-telesale'),
            dataSharingEmail: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-email'),
            dataSharingSms: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-sms'),
        };
        if (!regValid.length && !yearValid.length) {
            this.showDisplayView("loader");
            // variables
            var url = this.baseUrl + "/bcleadUtils/save-shariah-overdraft-lead";
            // config
            var _config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            };
            // service
            this.formsService.postForm(url, _postData, _config).then(function (response) {
                var _response = response.data;
                if (_response.toString().includes('invalid')) {
                    // service failed
                    analyticsService.dtmFormComplete("complete", "false");
                    _this.showDisplayView("fail");
                }
                else {
                    if (_displayName) {
                        _displayName.map(function (pElement) {
                            pElement.innerHTML = _postData.firstname;
                        });
                    }
                    analyticsService.dtmFormComplete("complete", "true");
                    _this.showDisplayView("success");
                }
            }).catch(function (response) {
                // service failed
                analyticsService.dtmFormComplete("complete", "false");
                this.showDisplayView("fail");
            });
        }
        else {
            window.scrollTo(0, 0);
        }
    };
    return FormItemShariahOverdraft;
}(Base));
export { FormItemShariahOverdraft };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-shariah-overdraft/form-item-shariah-overdraft.component.ts
// module id = 1089
// module chunks = 0